var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAccountFill = function SvgAccountFill(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18463_51677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.675 15.2917L12.675 12.7917C13.0584 12.5917 13.4167 12.3417 13.7417 12.0583C14.8834 11.0583 15.6 9.59167 15.6 7.95833C15.6 4.95 13.1584 2.5 10.1417 2.5C7.12503 2.5 4.69169 4.94167 4.69169 7.95833C4.69169 9.59167 5.40836 11.0583 6.55003 12.0583C6.87503 12.3417 7.23336 12.5917 7.61669 12.7917L4.61669 15.2917C3.71669 16.0417 4.25003 17.5 5.41669 17.5H14.875C16.0417 17.5 16.575 16.0417 15.675 15.2917Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18463_51677"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.9667,
    height: 15,
    fill: "white",
    transform: "translate(4.16669 2.5)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAccountFill);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "account-fill.d09f51571c2b68962cfda18146045632.svg";